import { GET_LOCATION_DATA_ENDPOINT } from '@shared/endpoints';
import { hideLoading, showError, showLoading } from './ui';
/* Fetch location data from the backend API */
export async function fetchLocationData(lat, lon) {
    const params = { lat: lat.toString(), lon: lon.toString() };
    const paramsString = new URLSearchParams(params).toString();
    showLoading();
    try {
        const response = await fetch(`${GET_LOCATION_DATA_ENDPOINT}?${paramsString}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        hideLoading();
        return data;
    }
    catch (error) {
        console.error('Error fetching location data:', error);
        hideLoading();
        showError('Failed to load location data. Please try again.');
        return null;
    }
}
